function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    console.log(this)
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.currentPageDot = this.querySelector('.slider-counter--dots');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;

      console.log(this.currentPage)

      this.querySelectorAll('.dot-slider').forEach(function(dotSlider) {
        dotSlider.classList.remove('active');
      });
      var dotSliderWithAttribute = this.querySelector('.dot-slider[data-side="'+this.currentPage+'"]');
      if (dotSliderWithAttribute) {
          dotSliderWithAttribute.classList.add('active');
      }
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    
    // Add debouncing to prevent rapid event firing
    this.debouncedOnOptionChange = debounce(this.onOptionChange.bind(this), 100);
    this.debouncedOnVariantChange = debounce(this.onVariantChange.bind(this), 100);
    
    this.addEventListener('change', this.debouncedOnVariantChange);
    this.querySelectorAll('select, fieldset').forEach((element) => {
      element.addEventListener('change', (event) => {
        this.debouncedOnOptionChange(event);
      });
    });
  }

  connectedCallback() {
    // Initialize variant statuses when component is connected
    this.updateOptions();
    
    // Try to validate URL variant first, then fall back to default selection
    const urlVariantValid = this.validateUrlVariant();
    if (!urlVariantValid) {
      this.ensureValidInitialSelection();
    }
    
    // Force update variant statuses after initialization - with proper sequencing
    setTimeout(() => {
      // Always update variant statuses first to filter options properly
      this.updateVariantStatuses();
      this.syncCustomSelects();
      this.ensureInitialDisplaySync();
      
      // If we have a URL variant, ensure it's properly applied after filtering
      if (urlVariantValid) {
        setTimeout(() => {
          this.updateVariantStatuses();
          this.syncCustomSelects();
        }, 50);
      }
      
      // Final check to ensure variant filtering is applied correctly
      setTimeout(() => {
        this.forceVariantFiltering();
      }, 200);
    }, 100);
    
    // Debug logging for troubleshooting
    setTimeout(() => {
      this.debugVariantState();
      this.testVariantPicker();
    }, 500);
    
    // Listen for URL changes (e.g., browser back/forward buttons)
    window.addEventListener('popstate', () => {
      this.handleUrlChange();
    });
  }

  ensureInitialDisplaySync() {
    console.log('=== ENSURING INITIAL DISPLAY SYNC ===');
    
    // Ensure size matches temperature on initial load
    this.ensureSizeMatchesTemperature();
    
    // Force sync custom selects one more time after everything is set
    setTimeout(() => {
      this.syncCustomSelects();
      console.log('=== INITIAL DISPLAY SYNC COMPLETE ===');
    }, 50);
  }

  syncCustomSelects() {
    console.log('=== SYNCING CUSTOM SELECTS ===');
    
    this.querySelectorAll('custom-select').forEach((customSelect, index) => {
      const select = customSelect.querySelector('select');
      if (!select) return;
      
      const currentValue = select.value;
      console.log(`Custom select ${index} current value:`, currentValue);
      
      // Update the display board
      const board = customSelect.querySelector('.custom-select__board');
      if (board) {
        const option = select.querySelector(`option[value="${currentValue}"]`);
        if (option) {
          board.textContent = option.textContent.trim();
          console.log(`Updated board for custom select ${index} to:`, option.textContent.trim());
        }
      }
      
      // Update selected classes in popovers
      const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
      if (desktopPopover) {
        desktopPopover.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        const matchingOption = desktopPopover.querySelector(`li[data-value="${currentValue}"]`);
        if (matchingOption) {
          matchingOption.classList.add('selected');
        }
      }
      
      const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
      if (mobilePopover) {
        const mobileOptions = mobilePopover.querySelector('.popover-options');
        if (mobileOptions) {
          mobileOptions.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
          const matchingMobileOption = mobileOptions.querySelector(`li[data-value="${currentValue}"]`);
          if (matchingMobileOption) {
            matchingMobileOption.classList.add('selected');
          }
        }
      }
    });
    
    console.log('=== CUSTOM SELECTS SYNCED ===');
  }

  forceRefreshVariantStatuses() {
    console.log('=== FORCE REFRESH VARIANT STATUSES ===');
    this.updateOptions();
    this.updateVariantStatuses();
    console.log('=== FORCE REFRESH COMPLETE ===');
  }

  forceVariantFiltering() {
    console.log('=== FORCE VARIANT FILTERING ===');
    
    // Ensure we have the correct options from URL or current state
    this.updateOptions();
    
    // Get current temperature from URL if available
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Ensure we have variant data
      if (!this.variantData || this.variantData.length === 0) {
        this.variantData = this.getVariantData();
      }
      
      const urlVariant = this.variantData.find(variant => variant.id.toString() === variantId);
      if (urlVariant && urlVariant.available) {
        console.log('Forcing variant filtering for URL variant:', urlVariant);
        
        // Ensure options match the URL variant
        this.options[0] = urlVariant.option1;
        this.options[1] = urlVariant.option2;
        
        // Update UI selections to match
        this.updateFirstOptionSelection(urlVariant.option1);
        this.updateSecondOptionSelection(urlVariant.option2);
      }
    }
    
    // Force update variant statuses to filter size options based on temperature
    this.updateVariantStatuses();
    
    // Sync custom selects to ensure proper display
    this.syncCustomSelects();
    
    // Update master ID and URL
    this.updateMasterId();
    this.updateURL();
    this.updateVariantInput();
    
    console.log('=== FORCE VARIANT FILTERING COMPLETE ===');
    console.log('Final options:', this.options);
    console.log('Final variant:', this.currentVariant);
  }

  // Method to be called from custom select when temperature changes
  onTemperatureChange(newTemperature) {
    console.log('=== TEMPERATURE CHANGE DETECTED ===');
    console.log('New temperature:', newTemperature);
    console.log('Previous options:', this.options);
    
    // Update the first option (temperature)
    if (this.options[0] !== newTemperature) {
      this.options[0] = newTemperature;
      console.log('Updated temperature option to:', newTemperature);
      
      // Force update variant statuses to filter size options
      this.updateVariantStatuses();
      
      // Find the first available size for the new temperature and auto-select it
      const variantsForNewTemperature = this.variantData.filter(variant => {
        return variant.option1 === newTemperature;
      });
      
      if (variantsForNewTemperature.length > 0) {
        const firstAvailableSize = variantsForNewTemperature[0].option2;
        console.log('Auto-selecting first available size:', firstAvailableSize);
        
        // Update the second option (size)
        if (this.options[1] !== firstAvailableSize) {
          this.options[1] = firstAvailableSize;
          console.log('Updated size option to:', firstAvailableSize);
          
          // Find and update the size input
          const sizeInputWrapper = Array.from(this.querySelectorAll('.product-form__input')).find((wrapper, index) => index === 1);
          if (sizeInputWrapper) {
            if (sizeInputWrapper.querySelector('custom-select')) {
              const customSelect = sizeInputWrapper.querySelector('custom-select');
              const select = customSelect.querySelector('select');
              if (select) {
                select.value = firstAvailableSize;
                
                // Update the custom select display board IMMEDIATELY
                const board = customSelect.querySelector('.custom-select__board');
                if (board) {
                  // Find the option text for the new size
                  const option = select.querySelector(`option[value="${firstAvailableSize}"]`);
                  if (option) {
                    board.textContent = option.textContent.trim();
                    console.log('Updated size display board to:', option.textContent.trim());
                  } else {
                    board.textContent = firstAvailableSize;
                    console.log('Updated size display board to:', firstAvailableSize);
                  }
                }
                
                // Update selected classes in both desktop and mobile popovers IMMEDIATELY
                const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
                const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
                
                // Update desktop popover
                if (desktopPopover) {
                  desktopPopover.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
                  const matchingOption = desktopPopover.querySelector(`li[data-value="${firstAvailableSize}"]`);
                  if (matchingOption) {
                    matchingOption.classList.add('selected');
                    console.log('Updated desktop popover selection to:', firstAvailableSize);
                  }
                }
                
                // Update mobile popover (mobile has nested structure)
                if (mobilePopover) {
                  const mobileOptions = mobilePopover.querySelector('.popover-options');
                  if (mobileOptions) {
                    mobileOptions.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
                    const matchingMobileOption = mobileOptions.querySelector(`li[data-value="${firstAvailableSize}"]`);
                    if (matchingMobileOption) {
                      matchingMobileOption.classList.add('selected');
                      console.log('Updated mobile popover selection to:', firstAvailableSize);
                    }
                  }
                }
                
                // Force a small delay to ensure the display is updated before triggering change event
                setTimeout(() => {
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }, 50);
              }
            } else if (sizeInputWrapper.querySelector('select')) {
              // Handle regular select dropdowns
              const select = sizeInputWrapper.querySelector('select');
              if (select) {
                select.value = firstAvailableSize;
                setTimeout(() => {
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }, 50);
              }
            } else if (sizeInputWrapper.querySelector('input[type="radio"]')) {
              // Handle radio button groups
              const radioInput = sizeInputWrapper.querySelector(`input[value="${firstAvailableSize}"]`);
              if (radioInput) {
                radioInput.checked = true;
                setTimeout(() => {
                  radioInput.dispatchEvent(new Event('change', { bubbles: true }));
                }, 50);
              }
            }
          }
        }
      }
      
      // Update master ID to find the correct variant
      this.updateMasterId();
      
      // Update URL and other components
      this.updateURL();
      this.updateVariantInput();
    }
    
    console.log('=== TEMPERATURE CHANGE COMPLETE ===');
  }

  testVariantPicker() {
    console.log('=== TESTING VARIANT PICKER ===');
    console.log('Current options:', this.options);
    console.log('Current variant:', this.currentVariant);
    console.log('Variant data length:', this.variantData.length);
    
    // Test temperature selection
    const temperatureWrapper = this.querySelector('.product-form__input');
    if (temperatureWrapper) {
      const temperatureValue = temperatureWrapper.querySelector(':checked')?.value || 
                              temperatureWrapper.querySelector('select')?.value ||
                              temperatureWrapper.querySelector('custom-select select')?.value;
      console.log('Temperature wrapper found, current value:', temperatureValue);
    }
    
    // Test size selection
    const sizeWrapper = Array.from(this.querySelectorAll('.product-form__input')).find((wrapper, index) => index === 1);
    if (sizeWrapper) {
      const sizeValue = sizeWrapper.querySelector(':checked')?.value || 
                       sizeWrapper.querySelector('select')?.value ||
                       sizeWrapper.querySelector('custom-select select')?.value;
      console.log('Size wrapper found, current value:', sizeValue);
      
      // Test custom select
      const customSelect = sizeWrapper.querySelector('custom-select');
      if (customSelect) {
        console.log('Custom select found for size');
        const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
        if (mobilePopover) {
          const mobileOptions = mobilePopover.querySelector('.popover-options');
          if (mobileOptions) {
            const options = mobileOptions.querySelectorAll('li');
            console.log('Mobile size options found:', options.length);
            options.forEach((option, index) => {
              console.log(`Option ${index}:`, {
                value: option.dataset.value,
                disabled: option.classList.contains('disabled'),
                display: option.style.display,
                selected: option.classList.contains('selected')
              });
            });
          }
        }
      }
    }
    
    console.log('=== END VARIANT PICKER TEST ===');
  }

  handleUrlChange() {
    console.log('URL changed, updating variant picker');
    if (this.validateUrlVariant()) {
      this.updateVariantStatuses();
      this.updateMasterId();
    }
  }

  ensureValidInitialSelection() {
    // Check if current selection is valid, if not, find a valid one
    if (!this.currentVariant || !this.currentVariant.available) {
      const firstAvailableVariant = this.variantData.find(variant => variant.available);
      if (firstAvailableVariant) {
        console.log('Setting initial variant to:', firstAvailableVariant);
        
        // Update the first option (temperature)
        if (this.options[0] !== firstAvailableVariant.option1) {
          this.options[0] = firstAvailableVariant.option1;
          this.updateFirstOptionSelection(firstAvailableVariant.option1);
        }
        
        // Update the second option (size)
        if (this.options[1] !== firstAvailableVariant.option2) {
          this.options[1] = firstAvailableVariant.option2;
          this.updateSecondOptionSelection(firstAvailableVariant.option2);
        }
        
        // Update the UI
        this.updateVariantStatuses();
        this.updateMasterId();
      }
    } else {
      // Current variant is valid, ensure UI is synchronized
      console.log('Current variant is valid:', this.currentVariant);
      this.updateVariantStatuses();
      
      // Ensure size selection matches the current temperature
      this.ensureSizeMatchesTemperature();
    }
  }

  ensureSizeMatchesTemperature() {
    // Get current temperature
    const currentTemperature = this.options[0];
    if (!currentTemperature) return;
    
    // Get available sizes for current temperature
    const availableSizes = this.variantData
      .filter(variant => variant.option1 === currentTemperature)
      .map(variant => variant.option2);
    
    if (availableSizes.length === 0) return;
    
    // Check if current size is available for current temperature
    const currentSize = this.options[1];
    if (!currentSize || !availableSizes.includes(currentSize)) {
      // Auto-select first available size
      const newSize = availableSizes[0];
      console.log('Auto-selecting size', newSize, 'for temperature', currentTemperature);
      
      this.options[1] = newSize;
      this.updateSecondOptionSelection(newSize);
      
      // Force immediate UI update for custom selects
      const sizeInputWrapper = Array.from(this.querySelectorAll('.product-form__input')).find((wrapper, index) => index === 1);
      if (sizeInputWrapper && sizeInputWrapper.querySelector('custom-select')) {
        const customSelect = sizeInputWrapper.querySelector('custom-select');
        const select = customSelect.querySelector('select');
        if (select) {
          select.value = newSize;
          
          // Update display board immediately
          const board = customSelect.querySelector('.custom-select__board');
          if (board) {
            const option = select.querySelector(`option[value="${newSize}"]`);
            if (option) {
              board.textContent = option.textContent.trim();
              console.log('Updated size display board to:', option.textContent.trim());
            } else {
              board.textContent = newSize;
              console.log('Updated size display board to:', newSize);
            }
          }
          
          // Update popover selections immediately
          const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
          if (desktopPopover) {
            desktopPopover.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
            const matchingOption = desktopPopover.querySelector(`li[data-value="${newSize}"]`);
            if (matchingOption) {
              matchingOption.classList.add('selected');
            }
          }
          
          const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
          if (mobilePopover) {
            const mobileOptions = mobilePopover.querySelector('.popover-options');
            if (mobileOptions) {
              mobileOptions.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
              const matchingMobileOption = mobileOptions.querySelector(`li[data-value="${newSize}"]`);
              if (matchingMobileOption) {
                matchingMobileOption.classList.add('selected');
              }
            }
          }
        }
      }
      
      // Update variant statuses to reflect the change
      this.updateVariantStatuses();
      this.updateMasterId();
      this.updateURL();
      this.updateVariantInput();
    }
  }

  validateUrlVariant() {
    // Check if URL contains a variant ID and validate it
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId) {
      // Ensure we have variant data
      if (!this.variantData || this.variantData.length === 0) {
        this.variantData = this.getVariantData();
      }
      
      const urlVariant = this.variantData.find(variant => variant.id.toString() === variantId);
      if (urlVariant && urlVariant.available) {
        console.log('URL variant is valid:', urlVariant);
        
        // Update options to match URL variant
        if (this.options[0] !== urlVariant.option1) {
          this.options[0] = urlVariant.option1;
          this.updateFirstOptionSelection(urlVariant.option1);
        }
        if (this.options[1] !== urlVariant.option2) {
          this.options[1] = urlVariant.option2;
          this.updateSecondOptionSelection(urlVariant.option2);
        }
        
        // Force immediate update of variant statuses to filter size options
        this.updateVariantStatuses();
        this.updateMasterId();
        
        // Sync custom selects to reflect the URL variant
        setTimeout(() => {
          this.syncCustomSelects();
        }, 50);
        
        return true;
      } else {
        console.log('URL variant is invalid or unavailable:', variantId);
        return false;
      }
    }
    return false;
  }

  debugVariantState() {
    console.log('=== VARIANT PICKER DEBUG STATE ===');
    console.log('Current options:', this.options);
    console.log('Current variant:', this.currentVariant);
    console.log('Variant data:', this.variantData);
    console.log('Available variants:', this.variantData.filter(v => v.available));
    
    // Log input states
    this.querySelectorAll('.product-form__input').forEach((wrapper, index) => {
      console.log(`Input wrapper ${index}:`, {
        type: wrapper.querySelector('input[type="radio"]') ? 'radio' : 
              wrapper.querySelector('custom-select') ? 'custom-select' : 'select',
        value: wrapper.querySelector(':checked')?.value || 
               wrapper.querySelector('select')?.value ||
               wrapper.querySelector('custom-select select')?.value,
        legend: wrapper.querySelector('legend')?.textContent
      });
    });
    console.log('=== END DEBUG STATE ===');
  }

  updateFirstOptionSelection(value) {
    // Update first option selection (temperature)
    const firstInputWrapper = this.querySelector('.product-form__input');
    if (firstInputWrapper) {
      if (firstInputWrapper.querySelector('input[type="radio"]')) {
        const radioInput = firstInputWrapper.querySelector(`input[value="${value}"]`);
        if (radioInput) {
          radioInput.checked = true;
        }
      } else if (firstInputWrapper.querySelector('custom-select')) {
        const customSelect = firstInputWrapper.querySelector('custom-select');
        const select = customSelect.querySelector('select');
        if (select) {
          select.value = value;
          
          // Update custom select display board
          const board = customSelect.querySelector('.custom-select__board');
          if (board) {
            const option = select.querySelector(`option[value="${value}"]`);
            if (option) {
              board.textContent = option.textContent.trim();
            } else {
              board.textContent = value;
            }
          }
          
          // Update popover selections
          const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
          if (desktopPopover) {
            desktopPopover.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
            const matchingOption = desktopPopover.querySelector(`li[data-value="${value}"]`);
            if (matchingOption) {
              matchingOption.classList.add('selected');
            }
          }
          
          const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
          if (mobilePopover) {
            const mobileOptions = mobilePopover.querySelector('.popover-options');
            if (mobileOptions) {
              mobileOptions.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
              const matchingMobileOption = mobileOptions.querySelector(`li[data-value="${value}"]`);
              if (matchingMobileOption) {
                matchingMobileOption.classList.add('selected');
              }
            }
          }
        }
      } else if (firstInputWrapper.querySelector('select')) {
        const select = firstInputWrapper.querySelector('select');
        if (select) {
          select.value = value;
        }
      }
    }
  }

  updateSecondOptionSelection(value) {
    // Update second option selection (size)
    const secondInputWrapper = Array.from(this.querySelectorAll('.product-form__input')).find((wrapper, index) => index === 1);
    if (secondInputWrapper) {
      if (secondInputWrapper.querySelector('input[type="radio"]')) {
        const radioInput = secondInputWrapper.querySelector(`input[value="${value}"]`);
        if (radioInput) {
          radioInput.checked = true;
        }
      } else if (secondInputWrapper.querySelector('custom-select')) {
        const customSelect = secondInputWrapper.querySelector('custom-select');
        const select = customSelect.querySelector('select');
        if (select) {
          select.value = value;
          
          // Update custom select display board
          const board = customSelect.querySelector('.custom-select__board');
          if (board) {
            const option = select.querySelector(`option[value="${value}"]`);
            if (option) {
              board.textContent = option.textContent.trim();
            } else {
              board.textContent = value;
            }
          }
          
          // Update popover selections
          const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
          if (desktopPopover) {
            desktopPopover.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
            const matchingOption = desktopPopover.querySelector(`li[data-value="${value}"]`);
            if (matchingOption) {
              matchingOption.classList.add('selected');
            }
          }
          
          const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
          if (mobilePopover) {
            const mobileOptions = mobilePopover.querySelector('.popover-options');
            if (mobileOptions) {
              mobileOptions.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
              const matchingMobileOption = mobileOptions.querySelector(`li[data-value="${value}"]`);
              if (matchingMobileOption) {
                matchingMobileOption.classList.add('selected');
              }
            }
          }
        }
      } else if (secondInputWrapper.querySelector('select')) {
        const select = secondInputWrapper.querySelector('select');
        if (select) {
          select.value = value;
        }
      }
    }
  }

  onOptionChange(event) {
    // Prevent rapid firing of events
    if (this.isProcessingChange) {
      console.log('Change already being processed, skipping...');
      return;
    }
    
    this.isProcessingChange = true;
    
    try {
      this.updateOptions();
      
      console.log('=== OPTION CHANGE DEBUG ===');
      console.log('Changed option:', event.target.name, 'to value:', event.target.value);
      console.log('Current options array:', this.options);
      
      // If this is the first variant (temperature) changing, reset the second variant (size) if needed
      const target = event.target;
      if (target.name === 'options[Temperature]' || target.name === 'options[דרגת חום]' || 
          (target.closest('.product-form__input') && target.closest('.product-form__input').querySelector('legend')?.textContent.includes('Temperature') || 
           target.closest('.product-form__input')?.querySelector('legend')?.textContent.includes('דרגת חום'))) {
        
        console.log('Temperature variant changed, checking size reset...');
        
        // Find the second variant input (size)
        const sizeInputWrapper = Array.from(this.querySelectorAll('.product-form__input')).find((wrapper, index) => index === 1);
        if (sizeInputWrapper) {
          const currentSizeValue = sizeInputWrapper.querySelector(':checked')?.value || 
                                  sizeInputWrapper.querySelector('select')?.value ||
                                  sizeInputWrapper.querySelector('custom-select select')?.value;
          
          // Get available sizes for the new temperature
          const newTemperatureValue = target.value;
          const availableSizes = this.variantData
            .filter(variant => variant.option1 === newTemperatureValue)
            .map(variant => variant.option2);
          
          console.log('Temperature changed to:', newTemperatureValue);
          console.log('Available sizes for new temperature:', availableSizes);
          console.log('Current size selection:', currentSizeValue);
          
          // If current size is not available for new temperature, reset to first available size
          if (currentSizeValue && !availableSizes.includes(currentSizeValue) && availableSizes.length > 0) {
            const newSizeValue = availableSizes[0];
            console.log('Resetting size from', currentSizeValue, 'to', newSizeValue);
            
            // Update the size selection
            if (sizeInputWrapper.querySelector('input[type="radio"]')) {
              const radioInput = sizeInputWrapper.querySelector(`input[value="${newSizeValue}"]`);
              if (radioInput) {
                radioInput.checked = true;
                // Use setTimeout to prevent rapid event firing
                setTimeout(() => {
                  radioInput.dispatchEvent(new Event('change', { bubbles: true }));
                }, 50);
              }
            } else if (sizeInputWrapper.querySelector('custom-select')) {
              const customSelect = sizeInputWrapper.querySelector('custom-select');
              const select = customSelect.querySelector('select');
              if (select) {
                select.value = newSizeValue;
                
                // Update the custom select display board
                const board = customSelect.querySelector('.custom-select__board');
                if (board) {
                  board.textContent = newSizeValue;
                  console.log('Updated custom select display board to:', newSizeValue);
                }
                
                // Update selected classes in both desktop and mobile popovers
                const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
                const mobilePopover = customSelect.querySelector('.custom-select-mobile-overlay');
                
                // Update desktop popover
                if (desktopPopover) {
                  desktopPopover.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
                  const matchingOption = desktopPopover.querySelector(`li[data-value="${newSizeValue}"]`);
                  if (matchingOption) {
                    matchingOption.classList.add('selected');
                  }
                }
                
                // Update mobile popover (mobile has nested structure)
                if (mobilePopover) {
                  const mobileOptions = mobilePopover.querySelector('.popover-options');
                  if (mobileOptions) {
                    mobileOptions.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
                    const matchingMobileOption = mobileOptions.querySelector(`li[data-value="${newSizeValue}"]`);
                    if (matchingMobileOption) {
                      matchingMobileOption.classList.add('selected');
                    }
                  }
                }
                
                // Force a small delay to ensure the display is updated before triggering change event
                setTimeout(() => {
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }, 100);
              }
            } else if (sizeInputWrapper.querySelector('select')) {
              const select = sizeInputWrapper.querySelector('select');
              if (select) {
                select.value = newSizeValue;
                setTimeout(() => {
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                }, 50);
              }
            }
          }
        }
      }
      
      console.log('=== END OPTION CHANGE DEBUG ===');
      
      this.updateMasterId();
      this.updateVariantInput(); // Force sync with hidden input
      this.updateURL(); // Always update URL on any option change
      
      // Force update variant statuses to ensure size options are properly filtered
      this.updateVariantStatuses();
      
      this.dispatchEvent(new Event('change', { bubbles: true })); // Trigger parent listeners
    } finally {
      // Reset the processing flag after a delay to prevent rapid firing
      setTimeout(() => {
        this.isProcessingChange = false;
      }, 200);
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    //this.toggleAddButton(true, '', false);
    const disableImmediate = !this.currentVariant || !this.currentVariant.available;
    this.toggleAddButton(disableImmediate, undefined, true);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateURL(); // Always update URL on any variant change
    try {
      if (typeof window.NotifyMeByStok === 'function') {
        window.NotifyMeByStok(this.currentVariant ? this.currentVariant.id : undefined);
      }
    } catch (e) {}
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      // this.updateURL(); // Already called above
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value || element.querySelector('option[selected]')?.value || '';
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value || '';
      }
    });
    // Debug log to verify options
    console.log('Updated options:', this.options);
  }

  updateMasterId() {
    console.log('=== UPDATE MASTER ID START ===');
    this.variantData = this.getVariantData();
    console.log('Variant data loaded:', this.variantData.length, 'variants');
    console.log('Current options:', this.options);
    
    // First try to find exact match
    this.currentVariant = this.variantData.find((variant) => {
      const match = !variant.options
        .map((option, index) => {
          return this.options[index] === option || (this.options[index] === '' && variant.options[index] === null);
        })
        .includes(false);
      console.log('Checking variant:', variant, 'Match:', match);
      return match;
    }) || null;

    console.log('Exact match found:', this.currentVariant);

    // If no exact match found, try to find a variant that matches the first option (temperature)
    if (!this.currentVariant && this.options[0]) {
      console.log('No exact match, trying temperature match for:', this.options[0]);
      this.currentVariant = this.variantData.find((variant) => {
        return variant.option1 === this.options[0] && variant.available;
      }) || null;
      
      if (this.currentVariant) {
        console.log('Found variant by temperature match:', this.currentVariant);
        // Update the second option to match the found variant
        if (this.options[1] !== this.currentVariant.option2) {
          this.options[1] = this.currentVariant.option2;
          console.log('Updated size option to:', this.options[1]);
          
          // Update the UI to reflect this change
          this.updateVariantStatuses();
        }
      }
    }

    // If still no variant found, attempt to sync with custom select and retry
    if (!this.currentVariant) {
      console.log('Still no variant found, attempting custom select sync...');
      this.syncCustomSelectOptions();
      this.currentVariant = this.variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option || (this.options[index] === '' && variant.options[index] === null);
          })
          .includes(false);
      }) || null;
    }
    
    // Debug log to verify variant and options
    console.log('Final current variant:', this.currentVariant);
    console.log('Final options:', this.options);
    console.log('=== UPDATE MASTER ID END ===');
  }

  syncCustomSelectOptions() {
    // Attempt to sync with custom select component
    this.querySelectorAll('select').forEach((select) => {
      const customSelect = select.closest('.custom-select') || select.nextElementSibling?.classList.contains('custom-select') ? select.nextElementSibling : null;
      if (customSelect) {
        const selectedOption = customSelect.querySelector('.selected')?.getAttribute('data-value');
        if (selectedOption) {
          select.value = selectedOption;
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
        }
      }
    });
    this.updateOptions(); // Update options after sync
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // Check if media has actually changed to prevent unnecessary updates
    const currentMediaId = this.currentVariant.featured_media.id;
    const lastMediaId = this.lastMediaId;
    
    if (lastMediaId === currentMediaId) {
      console.log('Media unchanged, skipping update');
      return;
    }
    
    console.log('Media changed from', lastMediaId, 'to', currentMediaId);
    this.lastMediaId = currentMediaId;

    const allColors = this.getAllColors();

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.filterMediaByColor(this.currentVariant, allColors);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) {
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input && this.currentVariant) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updateVariantStatuses() {
    console.log('=== UPDATE VARIANT STATUSES START ===');
    console.log('Current options:', this.options);
    console.log('Variant data:', this.variantData);
    
    // Ensure we have variant data
    if (!this.variantData || this.variantData.length === 0) {
      this.variantData = this.getVariantData();
      console.log('Loaded variant data:', this.variantData.length, 'variants');
    }
    
    // Get the currently selected temperature (first option)
    let currentTemperature = this.options[0] || '';
    
    // If no temperature is selected, check URL or default to first available
    if (!currentTemperature) {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId) {
        const urlVariant = this.variantData.find(variant => variant.id.toString() === variantId);
        if (urlVariant && urlVariant.available) {
          currentTemperature = urlVariant.option1;
          this.options[0] = currentTemperature;
          console.log('Set temperature from URL variant:', currentTemperature);
        }
      }
      
      // If still no temperature, use first available variant's temperature
      if (!currentTemperature) {
        const firstAvailableVariant = this.variantData.find(variant => variant.available);
        if (firstAvailableVariant) {
          currentTemperature = firstAvailableVariant.option1;
          this.options[0] = currentTemperature;
          console.log('Set temperature from first available variant:', currentTemperature);
        }
      }
    }
    
    console.log('Current temperature selected:', currentTemperature);
    
    // Find all variants that match the current temperature
    const variantsForCurrentTemperature = this.variantData.filter(variant => {
      return variant.option1 === currentTemperature;
    });
    
    console.log('Variants for current temperature:', variantsForCurrentTemperature);
    
    // Get all available size options for the current temperature
    const availableSizes = [...new Set(variantsForCurrentTemperature
      .map(variant => variant.option2))];
    
    console.log('Available sizes for current temperature:', availableSizes);
    
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    console.log('Input wrappers found:', inputWrappers.length);
    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return; // Skip the first option (temperature)
      
      console.log(`Processing input wrapper ${index} (size):`, option);
      
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      
      // For the second variant (size), use the available sizes we calculated
      const availableOptionInputsValue = availableSizes;
      
      console.log('Available options for size variant:', availableOptionInputsValue);
      
      // Handle custom select dropdowns
      const customSelect = option.querySelector('custom-select');
      if (customSelect) {
        console.log('Handling custom select for size variant');
        this.updateCustomSelectAvailability(customSelect, availableOptionInputsValue);
      } else {
        console.log('Handling regular select for size variant');
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      }
    });
    
    console.log('=== UPDATE VARIANT STATUSES END ===');
  }

  updateCustomSelectAvailability(customSelect, availableValuesList) {
    const select = customSelect.querySelector('select');
    const desktopPopover = customSelect.querySelector('.custom-select-popover.desktop');
    // Mobile popover is stored as a property on the custom select element, not as a child
    const mobilePopover = customSelect.mobilePopover || document.querySelector('.custom-select-mobile-overlay');
    
    console.log('=== UPDATE CUSTOM SELECT AVAILABILITY ===');
    console.log('Available values list:', availableValuesList);
    console.log('Select element:', select);
    console.log('Desktop popover found:', !!desktopPopover);
    console.log('Mobile popover found:', !!mobilePopover);
    
    // Update desktop popover options
    if (desktopPopover) {
      const desktopOptions = desktopPopover.querySelectorAll('li');
      console.log('Desktop options found:', desktopOptions.length);
      
      desktopOptions.forEach(li => {
        const value = li.getAttribute('data-value');
        const isAvailable = availableValuesList.includes(value);
        
        console.log(`Desktop select option "${value}": available=${isAvailable}`);
        
        if (isAvailable) {
          li.classList.remove('disabled');
          li.style.display = '';
          li.style.pointerEvents = '';
          console.log(`Desktop option "${value}" is now visible and enabled`);
        } else {
          li.classList.add('disabled');
          li.style.display = 'none';
          li.style.pointerEvents = 'none';
          console.log(`Desktop option "${value}" is now hidden and disabled`);
        }
      });
    }
    
    // Update mobile popover options (mobile has nested structure)
    if (mobilePopover) {
      const mobileOptions = mobilePopover.querySelector('.popover-options');
      if (mobileOptions) {
        const mobileOptionItems = mobileOptions.querySelectorAll('li');
        console.log('Mobile options found:', mobileOptionItems.length);
        
        mobileOptionItems.forEach(li => {
          const value = li.getAttribute('data-value');
          const isAvailable = availableValuesList.includes(value);
          
          console.log(`Mobile select option "${value}": available=${isAvailable}`);
          
          if (isAvailable) {
            li.classList.remove('disabled');
            li.style.display = '';
            li.style.pointerEvents = '';
            console.log(`Mobile option "${value}" is now visible and enabled`);
          } else {
            li.classList.add('disabled');
            li.style.display = 'none';
            li.style.pointerEvents = 'none';
            console.log(`Mobile option "${value}" is now hidden and disabled`);
          }
        });
      } else {
        console.log('Mobile options container not found');
      }
    }
    
    // Also update the hidden select options
    if (select) {
      const selectOptions = Array.from(select.options);
      console.log('Hidden select options found:', selectOptions.length);
      
      selectOptions.forEach(option => {
        const isAvailable = availableValuesList.includes(option.value);
        console.log(`Hidden select option "${option.value}": available=${isAvailable}`);
        
        if (isAvailable) {
          option.style.display = '';
          option.disabled = false;
        } else {
          option.style.display = 'none';
          option.disabled = true;
        }
      });
    }
    
    console.log('=== END UPDATE CUSTOM SELECT AVAILABILITY ===');
    
    // Force rebuild mobile popover to ensure it shows the correct available options
    console.log('Checking mobile popover rebuild capability...');
    console.log('customSelect:', customSelect);
    console.log('rebuildMobilePopover method exists:', typeof customSelect.rebuildMobilePopover === 'function');
    console.log('buildMobilePopover method exists:', typeof customSelect.buildMobilePopover === 'function');
    
    if (customSelect && typeof customSelect.rebuildMobilePopover === 'function') {
      console.log('Forcing mobile popover rebuild for updated options');
      customSelect.rebuildMobilePopover();
    } else if (customSelect && typeof customSelect.buildMobilePopover === 'function') {
      console.log('Forcing mobile popover build for updated options');
      customSelect.buildMobilePopover();
    } else {
      console.log('No mobile popover rebuild method found on custom select');
      console.log('Available methods:', Object.getOwnPropertyNames(customSelect).filter(name => typeof customSelect[name] === 'function'));
      
      // Fallback: Force a manual mobile popover update by dispatching a custom event
      console.log('Attempting fallback mobile popover update...');
      const updateEvent = new CustomEvent('forceUpdateMobilePopover', {
        detail: { availableValues: availableValuesList }
      });
      customSelect.dispatchEvent(updateEvent);
    }
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant?.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    if (!requestedVariantId) return;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant?.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('span');

    const stickyAddButton = document.querySelector('.add_to_cart_float button');
    const stickyAddButtonText = stickyAddButton.querySelector('span');

    if (addButtonText && stickyAddButtonText) {
      stickyAddButtonText.innerHTML = addButtonText.innerHTML;
    }
    
    if (!addButton && !stickyAddButton) return;

    function replaceButtonLabelText(container, newText) {
      if (!container) return;
      function recurse(node) {
        for (let child of node.childNodes) {
          if (child.nodeType === Node.TEXT_NODE) {
            const val = child.textContent.trim();
            if (
              val.length && (
                val.toLowerCase().includes('add to cart') ||
                val.includes('הוספה לסל') ||
                val.includes('אזל המלאי')
              )
            ) {
              child.textContent = newText;
              return true;
            }
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            if (recurse(child)) return true;
          }
        }
        return false;
      }
      recurse(container);
    }

    if (!modifyClass) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      stickyAddButton.setAttribute('disabled', 'disabled');
      const soldText = text || (addButton.getAttribute('data-sold-out') || window.variantStrings.soldOut);
      replaceButtonLabelText(addButtonText, soldText);
      replaceButtonLabelText(stickyAddButtonText, soldText);
    } else {
      addButton.removeAttribute('disabled');
      stickyAddButton.removeAttribute('disabled');
      const addText = window.variantStrings.addToCart || 'Add to cart';
      replaceButtonLabelText(addButtonText, addText);
      replaceButtonLabelText(stickyAddButtonText, addText);
    }

  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    // addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getAllColors() {
    return [...new Set(this.getVariantData().map(variant => variant.option1.toLowerCase()))];
  }

  // Method to handle custom select changes
  handleCustomSelectChange(customSelect, newValue) {
    console.log('=== HANDLING CUSTOM SELECT CHANGE ===');
    console.log('Custom select:', customSelect);
    console.log('New value:', newValue);
    
    // Find which variant this custom select represents
    const inputWrapper = customSelect.closest('.product-form__input');
    if (!inputWrapper) return;
    
    const inputWrappers = Array.from(this.querySelectorAll('.product-form__input'));
    const index = inputWrappers.indexOf(inputWrapper);
    
    if (index === 0) {
      // This is the temperature variant
      console.log('Temperature variant changed to:', newValue);
      this.onTemperatureChange(newValue);
    } else if (index === 1) {
      // This is the size variant
      console.log('Size variant changed to:', newValue);
      if (this.options[1] !== newValue) {
        this.options[1] = newValue;
        this.updateMasterId();
        this.updateURL();
        this.updateVariantInput();
      }
    }
    
    console.log('=== CUSTOM SELECT CHANGE HANDLED ===');
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function bindZoomIconClick() {
  document.querySelectorAll('.product__media-icon').forEach(function(icon) {
    icon.style.cursor = 'pointer';
    icon.onclick = function(e) {
      const modalOpener = icon.closest('modal-opener');
      if (modalOpener) {
        const zoomBtn = modalOpener.querySelector('.product__media-toggle');
        if (zoomBtn) {
          zoomBtn.click();
        }
      }
      e.stopPropagation();
    };
  });
}

document.addEventListener('DOMContentLoaded', bindZoomIconClick);
document.addEventListener('shopify:section:load', bindZoomIconClick);

// MutationObserver for dynamic DOM changes (e.g., swatch/variant change)
const zoomIconObserver = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      if ([...mutation.addedNodes].some(node => node.querySelector && node.querySelector('.product__media-icon'))) {
        bindZoomIconClick();
      }
    }
  }
});
zoomIconObserver.observe(document.body, { childList: true, subtree: true });

function reinitProductModalGallery() {
  // Try to re-initialize the product modal/gallery if needed
  // Option 1: If there is a function, call it (add here if you find one)
  // Option 2: As a fallback, force close any open modal and reset active media
  // Option 3: Dispatch a click event on the first .product__media-toggle to force modal sync
  const openModal = document.querySelector('.product-media-modal[open]');
  if (openModal) {
    openModal.removeAttribute('open');
  }
  // Optionally, you can trigger a click on the first .product__media-toggle to sync
  // (This is a workaround for some Shopify themes)
  // const firstToggle = document.querySelector('.product__media-toggle');
  // if (firstToggle) firstToggle.click();
}

document.addEventListener('shopify:section:load', function() {
  bindZoomIconClick();
  reinitProductModalGallery();
});

// Add this function to replace the product modal HTML after AJAX product section change
function replaceProductModalForSection(sectionId, tempDiv) {
  const newModal = tempDiv.querySelector(`#ProductModal-${sectionId}`);
  const oldModal = document.querySelector(`#ProductModal-${sectionId}`);
  if (newModal && oldModal) {
    oldModal.replaceWith(newModal);
  }
}


